"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignments = exports.sizes = exports.variants = void 0;
var variants = ['cover', 'danger', 'facebook', 'ghost', 'ghost-gray', 'ghost-success', 'ghost-white', 'google', 'info', 'link', 'link-secondary', 'link-inverse', 'linkedin', 'minimal', 'outline', 'primary', 'primary-gray', 'secondary', 'success', 'twitter', 'warning'];
exports.variants = variants;
var sizes = ['xs', 'sm', 'small', 'normal', 'md', 'large', 'lg', 'xl'];
exports.sizes = sizes;
var alignments = ['left', 'center', 'right'];
exports.alignments = alignments;

//# sourceMappingURL=Button.propTypes.js.map